module.exports = __webpack_public_path__ + "img/akfel-wgc-paris-multitouch-application-07.40b3528c.jpg";